<template>
  <div class="container d-flex justify-content-center align-items-center" style="min-height: 80vh;">
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <h5 class="mb-0">{{ $t('profile.identity_confirmation_title') }}</h5>
        </div>
        <div class="card-body text-center">
          <div v-if="loading" class="py-3">
            <i class="fa fa-spinner fa-spin fa-2x mb-3"></i>
            <p class="mb-0">{{ $t('profile.identity_confirmation_loading') }}</p>
          </div>

          <div v-else-if="success" class="alert alert-success mb-3">
            {{ $t('profile.identity_confirmation_success') }}
          </div>

          <div v-else class="alert alert-danger mb-3">
            {{ error }}
          </div>

          <router-link class="btn btn-primary" to="/">
            {{ $t('profile.identity_confirmation_back_login') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ConfirmSanitization',
  data() {
    return {
      loading: true,
      success: false,
      error: null,
    };
  },
  async mounted() {
    const token = this.$route.params.token;
    const email = this.$route.query.email;

    if (!token || !email) {
      this.error = this.$t('profile.identity_confirmation_invalid');
      this.loading = false;
      return;
    }

    try {
      await this.$axios.post('/sanitization/confirm', { token, email });
      await this.setLogout();
      this.success = true;
    } catch (error) {
      this.error = error?.response?.data?.errors?.message?.[0]
        || error?.response?.data?.message
        || this.$t('profile.identity_confirmation_error');
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions('user', ['setLogout']),
  },
};
</script>